import React from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const DataGridSkeleton = (props?: any) => {
    const columnInfo = props?.columnInfo;
    return(
        <>
            <Table>
                <TableHead>
                    <TableRow style={{height: 30}}>
                    </TableRow>
                </TableHead>
                <TableBody style={{backgroundColor: '#F5F5F5'}}>
                    {Array.from(new Array(props?.numRows)).map((_, index) => (
                        <TableRow key={columnInfo[index]?.field} style={{height: 59}}>
                            {Array.from(new Array(props?.numCols)).map((_, index) => (
                                !columnInfo[index]?.hide &&
                                    <TableCell 
                                        className={columnInfo[index]?.cellClassName} 
                                        style={{width: columnInfo[index]?.maxWidth}} 
                                        key={columnInfo[index]?.headerName}>
                                        <Skeleton variant="text" width={'max-width'}/>
                                    </TableCell>
                                
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    )
}
export default DataGridSkeleton;